import { Component, Input } from '@angular/core';
import { EnrichedUser, UserService } from '@techspert-io/users';
import { Observable } from 'rxjs';
import { OmnisearchQueryResponse } from '../../models/omnisearch.models';

@Component({
  selector: 'app-omnisearch-result',
  templateUrl: './omnisearch-result.component.html',
  styleUrls: ['./omnisearch-result.component.scss'],
  standalone: false,
})
export class OmnisearchResultComponent {
  @Input() omnisearchResponse: OmnisearchQueryResponse;
  @Input() searchTerm: string;

  users$: Observable<Record<string, EnrichedUser>> =
    this.usersService.getInternalUsersDictionary();

  constructor(private usersService: UserService) {}

  getFullName(user?: Partial<EnrichedUser>): string {
    if (!user) {
      return 'unknown';
    }

    return user.first_name + ' ' + user.last_name;
  }
}
